import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Login from "./pages/login";
import CourseList from "./pages/course-list";
import Page from "./pages/page";
import Completed from "./pages/completed";
import CourseCatalog from "./pages/course-catalog";
import BlogList from "./pages/blog-list";
import Coach from "./pages/coach";
import Playground from "./pages/online-playground";
import ChatGPT from "./pages/chatgpt";
import ExamList from "./pages/exam-list";
import ExamRedirect from "./pages/exam/redirect";
import ExamPractice from "./pages/exam/practice";
import Promotion from "./pages/promotion";
import VipPage from "./pages/vip";
import Season from "./pages/season";
import SeasonTask from "./pages/season/task";
import TaskPunch from "./pages/season/task/punch";
import Page404 from "./pages/404";
import Challenges from "./pages/challenges";
import CoachProblem from "./pages/coach-problem";
import AppDownload from "./pages/app-download";
// import { useCrisp } from "@quark/customer-service";
import Qwerty from "./pages/qwerty";
import UserTaskList from "./pages/user/task/list";
import ChallengesGroup from "./pages/challenges-group";
import ContactPage from "./pages/contact";

function App() {
  // useCrisp();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/user" element={<Home />} />
      <Route path="course">
        <Route path="list" element={<CourseList />} />
        <Route path=":courseId">
          <Route path="catalog" element={<CourseCatalog />} />
          <Route path="coach/:coachId" element={<Coach />} />
          <Route path="page/:pageId" element={<Page />} />
          <Route path="page/:pageId/completed" element={<Completed />} />
        </Route>
      </Route>
      <Route path="/blog/list" element={<BlogList />} />
      <Route path="/exam/list" element={<ExamList />} />
      <Route path="/exam/:examId" element={<ExamRedirect />} />
      <Route path="/exam/:examId/:logId" element={<ExamPractice />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/chatgpt" element={<ChatGPT />} />
      <Route path="/promotion" element={<Promotion />} />
      <Route path="/vip" element={<VipPage />} />
      <Route path="/season/:seasonId" element={<Season />} />
      <Route path="/season/:seasonId/tasks" element={<SeasonTask />} />
      <Route
        path="/season/:seasonId/task/:taskId/punch/:subTaskId"
        element={<TaskPunch />}
      />
      <Route path="/problemset/:catalog/:page" element={<Challenges />} />
      <Route
        path="/problemset/:catalog/code/:challengeId"
        element={<CoachProblem />}
      />
      <Route path="/challenges-group/:courseNo" element={<ChallengesGroup />} />
      <Route path="/app-download" element={<AppDownload />} />
      <Route path="/qwerty" element={<Qwerty />} />
      <Route path="/user/tasks" element={<UserTaskList />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default App;
